import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { Invoice } from 'gung-standard';
import { JeevesInvoiceListConfigService } from 'gung-standard-jeeves';
import { SjoborgInvoiceCardListComponent } from '../components/sjoborg-invoice-card-list/sjoborg-invoice-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgInvoiceCardListConfigService extends JeevesInvoiceListConfigService {
  getLayouts(): ListLayout<Invoice>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgInvoiceCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Invoice grid'
      }
    ];
  }
}
